/**
 * THE CATEGORY LIST'S FILTERS on «Змагання» — remembered across page loads
 * (14 Oct 2026: «обрані фільтри теж давай будемо зберігати при
 * перевантаженні сторінки, щоб вони не злітали»), beside the competition
 * they filter (selectedCompetition.js).
 *
 * A filter is a plain {label, type[, property, value]} object; anything else
 * read back — an older shape, a hand-edited value — is dropped rather than
 * half-applied. Logging out forgets them (removeUserToken).
 */
const STORAGE_KEY = 'categoryListFilters';

const isFilter = filter => filter
    && 'object' === typeof filter
    && 'string' === typeof filter.label
    && 'string' === typeof filter.type;

/**
 * «Один учасник» became «Кількість спортсменів — До 1» (17 Oct 2026); one
 * remembered under its old name comes back as that range.
 */
const upgrade = filter => ('singleParticipant' === filter.type
    ? { label: '-1', type: 'participants', min: null, max: 1 }
    : filter);

export const getCategoryListFilters = () => {
    try {
        const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');

        return Array.isArray(stored) ? stored.filter(isFilter).map(upgrade) : [];
    } catch (e) {
        // Unreadable JSON, private browsing, a locked-down profile: start
        // with no filters rather than refuse to render.
        return [];
    }
};

export const storeCategoryListFilters = filters => {
    try {
        if (filters && filters.length) {
            window.localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
        } else {
            window.localStorage.removeItem(STORAGE_KEY);
        }
    } catch (e) {
        /* see getCategoryListFilters */
    }
};
